import React, {Component} from "react";

import './styles.scss';

export default class GroupTitle extends Component {

    render() {
        return (
            <div className={"group-name-section"}>
                <img src={this.props.img}/>
                <div className={"name"}>{this.props.name}</div>
            </div>

        );
    }
}





// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/ourPartners/components/groupTitle/GroupTitle.js